import React from 'react';

import { Card, Row, Col } from 'antd';

import { AssistanceSection } from './AssistanceSection';
import { SectionCard } from './SectionCard';
import { SecurityCodeSection } from './SecurityCodeSection';
import { ShipmentHeader } from './ShipmentHeader';
import { TelemetrySection } from './TelemetrySection';
import { useShipmentInspection } from '../hooks/useShipmentInspection';

interface ShipmentCardStaticProps {
  shipment: any;
  onStartInspection: (shipment: any) => void;
  className?: string;
  style?: React.CSSProperties;
  inspectionInProgress?: boolean;
}

/**
 * Static version of ShipmentCard with grid layout for SecurityInspection view.
 * Always expanded, no collapse functionality.
 * Layout: Header full-width, then 2 columns (Telemetry on left, Security + Assistance on right).
 */
export const ShipmentCardStatic = ({
  shipment,
  inspectionInProgress,
  onStartInspection,
  className,
  style,
}: ShipmentCardStaticProps) => {
  const {
    shipmentWithInspection,
    telemetryProps,
    securityCodeProps,
    assistanceProps,
  } = useShipmentInspection({
    shipment,
    enabled: true,
  });

  return (
    <Card
      className={className}
      style={{
        marginBottom: 16,
        borderColor: '#CCD8D6',
        boxShadow: '0rem .125rem .25rem 0rem #0000001A',
        ...style,
      }}
      styles={{
        body: {
          padding: '.75rem',
        },
      }}
    >
      <ShipmentHeader
        lpui={shipment?.lp_ui}
        carrierTrackingCode={shipment?.carrier?.tracking_code}
        inspectionInProgress={shipmentWithInspection?.inspection_in_progress}
      />

      <Row gutter={[16, 16]} style={{ marginTop: '16px' }}>
        {/* Telemetry Section */}
        <Col
          xs={24}
          sm={24}
          md={inspectionInProgress ? 24 : 12}
          lg={inspectionInProgress ? 24 : 8}
        >
          <SectionCard style={{ marginTop: 0 }}>
            <TelemetrySection {...telemetryProps} />
          </SectionCard>
        </Col>

        {/* Security Code + Assistance Sections */}
        {!inspectionInProgress && (
          <>
            <Col xs={24} sm={24} md={12} lg={8}>
              <SectionCard style={{ marginTop: 0 }}>
                <SecurityCodeSection {...securityCodeProps} />
              </SectionCard>
            </Col>
            <Col xs={24} sm={24} md={12} lg={8}>
              <SectionCard style={{ marginTop: 0 }}>
                <AssistanceSection
                  {...assistanceProps}
                  onRemoteControl={() =>
                    onStartInspection(shipmentWithInspection)
                  }
                />
              </SectionCard>
            </Col>
          </>
        )}
      </Row>
    </Card>
  );
};
